import React, { useState, useEffect, useRef } from "react";
import Home from "../../Components/Home/Home";
import Packages from "../../Components/Packages/Packages";
import Head from "../../Components/Home/Head";
import styles from "../../Components/Home/Home.module.css";
import SearchComponent from "../../Components/Utilities/SearchComponent";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getAllBranches } from "../../redux/Slices/Branches/thunk";
import { getAllPackages } from "../../redux/Slices/Packages/thunk";
import { getAllCategories } from "../../redux/Slices/Categories/thunk";
import { getOneUser } from "../../redux/Slices/users/thunk";
import { EmptyPaymentStatus, paymentStatus } from "../../redux/Slices/payment/thunk";
import {
  getLoyalPoint,
  reservationPackage,
  reservationService,
} from "../../redux/Slices/reservation/thunk";
import { getCarts } from "../../redux/Slices/Cart/thunk";
import { Modal, Button } from "react-bootstrap";
import done from "../../Images/done.svg";

const HomePage = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const [selectedOption, setSelectedOption] = useState(
    localStorage.getItem("branchId")
  );
  const dispatch = useDispatch();
  const navigate = useNavigate(); // Use navigate to update URL dynamically
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const paymentId = searchParams.get("paymentId");
  const parsedBranchId = localStorage?.getItem("branchId");
  const hasReserved = useRef(false); // لحفظ حالة الحجز

  const branchId =
    parsedBranchId && parsedBranchId !== "undefined"
      ? JSON.parse(parsedBranchId)
      : null;
  const user = JSON.parse(localStorage.getItem("user"));

  console.log("showSuccessModal", showSuccessModal);
  console.log("branchId", branchId);
  useEffect(() => {
    if (!branchId) {
      navigate("/branches");
    } else {
      dispatch(getAllBranches());
      dispatch(getAllPackages({ branchId }));
      dispatch(getAllCategories({ branchId }));
      dispatch(getOneUser(user?.cln_key));
      dispatch(getLoyalPoint({id:user?.cln_key}));
      dispatch(getCarts({ id: user?.cln_key }));
    }
    // return () => {
    //   localStorage.removeItem("reservationPackageData");
    //   localStorage.removeItem("reservationData");
    //   localStorage.removeItem("invoiceId");
    // };
  }, [branchId]);
  const branches = useSelector((state) => state.BranchesSlice);

  // useEffect(()=>{
  //   if(branches?.length > 0){
  //     const selectedBranch = branches?.find((el)=> branchId == el?.brn_num)
  //     console.log("selectedBranch",selectedBranch)
  //     setSelectedOption()
  //   }
  // },[branches])

  console.log("branches", branches?.Branches);
  // Example options array
  const options = Array.isArray(branches?.Branches)
    ? branches.Branches.map((branch) => ({
        value: branch.brn_num,
        label:
          currentLanguage === "ar"
            ? `${branch.brn_nam.trim()} ` // Arabic branch name
            : branch.brn_enm.trim() !== ""
            ? `${branch.brn_enm.trim()} ` // English branch name
            : `${branch.brn_nam.trim()} `, // Fallback to Arabic if English name is empty
      }))
    : [];

  // Handle onChange
  const handleChange = (selected) => {
    setSelectedOption(selected);
    console.log("Selected:", selected);
    if (selected?.value) {
      // Replace branchId in the URL
      navigate(`/HomePage`);
      localStorage.setItem("branchId", JSON.stringify(selected.value));
      console.log("BranchId Updated in URL:", selected.value);
    }
  };

  useEffect(() => {
    if (branchId) {
      const matchedOption = options.find((option) => option.value == branchId);
      // Only update state if the value actually changes
      setSelectedOption((prevOption) =>
        prevOption?.value !== matchedOption?.value
          ? matchedOption || null
          : prevOption
      );
      console.log("selectedOption", selectedOption);
    }
  }, [branchId, options]);

  //  for Payment
  const invoiceId = localStorage.getItem("invoiceId");
  const PaymentURL = localStorage.getItem("PaymentURL");
  // const url = new URL(PaymentURL);
  // const invoiceKey = url.searchParams.get('invoiceKey'); 

  const reservationData = JSON.parse(localStorage.getItem("reservationData"));
  const reservationPackageData = JSON.parse(
    localStorage.getItem("reservationPackageData")
  );
  const paymentStatusResponse = useSelector(
    (state) => state.paymentSlice.paymentStatusResponse
  );
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (invoiceId) {
      const data = {
        key: invoiceId,
        // isTest: true,
      };
      console.log("mokhtarTest");
      try {
        setLoading(true);
        console.log("data", data);
        dispatch(paymentStatus({ data }));
      } catch (err) {
        console.log("123123");
      } finally {
        setLoading(false);
      }
    } else {
      setLoading(false);
    }
  }, [invoiceId, dispatch]);

useEffect(()=>{
  if(showSuccessModal){
    localStorage.removeItem("reservationPackageData");
    localStorage.removeItem("reservationData");
    localStorage.removeItem("invoiceId");
    localStorage.removeItem("PaymentURL");

  }
},[showSuccessModal])
useEffect(() => {
  const handleReservationSuccess = async () => {
    console.log("zxczxczxc")
    if (
      !paymentStatusResponse ||
      hasReserved.current 
    )
      return;
    const invoiceStatus = paymentStatusResponse?.Data?.InvoiceStatus;
    console.log("reservationData", reservationData);
    console.log("invoiceStatus", invoiceStatus);
    if (invoiceStatus !== "Paid") return;

    console.log("invoiceStatus", invoiceStatus);
    hasReserved.current = true; 
    
    if (reservationData) {
      setShowSuccessModal(true);
      console.log("reservationData", reservationData);
      const data = {
        ...reservationData,
        paymentId,
        paymentLink: PaymentURL,
      };
      await dispatch(reservationService({ data }));
    }

    if (reservationPackageData) {
      setShowSuccessModal(true);
      console.log("reservationPackageData", reservationPackageData);
      const data = {
        ...reservationPackageData,
        paymentId,
        paymentLink: PaymentURL,
      };
      await dispatch(reservationPackage({ data }));
    }

     dispatch(EmptyPaymentStatus());
    await dispatch(getCarts({ id: user?.cln_key }));
  };

  handleReservationSuccess();
}, [
  paymentStatusResponse,
  reservationData,
  reservationPackageData,
  dispatch,
  paymentId,
  PaymentURL,
  user?.cln_key,
]);

  return (
    <div className="flex-grow-1">
      <Head branchId={branchId} />
      <div style={{ padding: "20px", maxWidth: "1000px", margin: "auto" }}>
        <SearchComponent
          options={options}
          onChange={handleChange}
          defaultValue={selectedOption}
          value={selectedOption}
          placeholder=""
          labelForOption="label"
          valueForOption="value"
          noOptionsMessage={t("no_matching_branches")}
        />
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      ></div>
      <div className={styles.loginContainer}>
        <div className={styles.loginHeader}>{t("Categories")}</div>
        <div className={styles.loginSecHeader}>
          {t("categories_special_and_custom")}
        </div>
      </div>

      <Home />

      <div className={styles.loginContainer}>
        <div className={styles.loginHeader}>{t("Packages")}</div>
        <div className={styles.loginSecHeader}>
          {t("BrowseTheExclusiveAndSpecializedPackages")}
        </div>
      </div>

      <Packages />

      <Modal
        show={showSuccessModal}
        onHide={() => setShowSuccessModal(false)}
        centered
      >
        <Modal.Body className="text-center p-5">
          <div>
            <svg
              width="80"
              height="80"
              viewBox="0 0 80 80"
              className="checkmark"
              style={{ fill: "none", stroke: "#3A5F0B", strokeWidth: 8 }}
            >
              <circle cx="40" cy="40" r="35" strokeOpacity="0.2" />
              <path
                d="M25 40 L35 50 L55 30"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>

          <h4
            className="mt-4 mb-3"
            style={{ color: "#3A5F0B", fontWeight: 600 }}
          >
            {t("payment.success")}
          </h4>
        </Modal.Body>
      </Modal>
    </div>
  );
};
export default HomePage;
